
(function () {
  function initTermsCheckbox() {
    const checkbox = document.getElementById('drawer-accept-terms');
    const error = document.getElementById('drawer-terms-error');

    if (!checkbox) return;

    // Evita registrar el evento varias veces
    if (checkbox.dataset.termsInitialized === 'true') return;
    checkbox.dataset.termsInitialized = 'true';

    // Ocultar error cuando el cliente acepta
    checkbox.addEventListener('change', function () {
      if (checkbox.checked && error) {
        error.style.display = 'none';
      }
    });

    // Buscar botones/enlaces de checkout
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout"]'
    );

    checkoutButtons.forEach(function (button) {

      if (button.dataset.termsListener === 'true') return;
      button.dataset.termsListener = 'true';

      button.addEventListener('click', function (event) {

        if (!checkbox.checked) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (error) {
            error.style.display = 'block';
          }

          checkbox.focus();

          return false;
        }

      }, true);
    });
  }

  // Primera carga
  initTermsCheckbox();

  // Highlight puede actualizar/re-renderizar el cart drawer
  document.addEventListener('DOMContentLoaded', initTermsCheckbox);

  // Vigilar cambios en el DOM del cart drawer
  const observer = new MutationObserver(function () {
    initTermsCheckbox();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("accept-terms");
  const checkoutBtn = document.querySelector('button[name="checkout"], button.cart__checkout-button');
  const errorMsg = document.getElementById("terms-error");

  if (checkoutBtn && checkbox) {
    console.log('checked');
    checkoutBtn.disabled = true;

    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        checkoutBtn.disabled = false;
        errorMsg.style.display = "none";
      } else {
        checkoutBtn.disabled = true;
      }
    });

  } else {
    if(checkoutBtn) {
      checkoutBtn.addEventListener("click", function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          errorMsg.style.display = "block";
        }
      });
    }
  }
});

function addDrawerTermsValidation() {
        const drawerCheckbox = document.getElementById("drawer-accept-terms");
        const drawerCheckoutBtn = document.getElementById("CartDrawer-Checkout");
        const drawerErrorMsg = document.getElementById("drawer-terms-error");

        if (drawerCheckbox && drawerCheckoutBtn && drawerErrorMsg) {
          if (drawerCheckoutBtn.dataset.termsHandlerAttached === "true") return;

          drawerCheckoutBtn.disabled = true;

          drawerCheckbox.addEventListener("change", function () {
            if (drawerCheckbox.checked) {
              drawerCheckoutBtn.disabled = false;
              drawerErrorMsg.style.display = "none";
            } else {
              drawerCheckoutBtn.disabled = true;
            }
          });

          drawerCheckoutBtn.addEventListener("click", function (e) {
            if (!drawerCheckbox.checked) {
              e.preventDefault();
              drawerErrorMsg.style.display = "block";
            }
          });

          drawerCheckoutBtn.dataset.termsHandlerAttached = "true";
        }
      }

      function addCartPageTermsValidation() {
        const cartCheckbox = document.getElementById("accept-terms");
        const cartCheckoutBtn = document.querySelector('form[action$="/cart"] button[name="checkout"]');
        const cartErrorMsg = document.getElementById("terms-error");

        if (cartCheckbox && cartCheckoutBtn && cartErrorMsg) {
          if (cartCheckoutBtn.dataset.termsHandlerAttached === "true") return;

          cartCheckoutBtn.disabled = true;

          cartCheckbox.addEventListener("change", function () {
            if (cartCheckbox.checked) {
              cartCheckoutBtn.disabled = false;
              cartErrorMsg.classList.remove("show");
            } else {
              cartCheckoutBtn.disabled = true;
            }
          });

          cartCheckoutBtn.addEventListener("click", function (e) {
            if (!cartCheckbox.checked) {
              e.preventDefault();
              cartErrorMsg.classList.add("show");
            }
          });

          cartCheckoutBtn.dataset.termsHandlerAttached = "true";
        }
      }

      // Observa el drawer cuando aparezca
      function waitForDrawerAndObserve() {
        const checkDrawerInterval = setInterval(() => {
          const drawer = document.getElementById("CartDrawer");
          if (drawer) {
            console.log("✅ Drawer encontrado, inicializando observador...");
            clearInterval(checkDrawerInterval);

            const observer = new MutationObserver(() => {
              addDrawerTermsValidation();
            });

            observer.observe(drawer, { childList: true, subtree: true });

            // Ejecuta una vez por si ya está cargado
            addDrawerTermsValidation();
          } else {
            //console.log("⏳ Esperando a que CartDrawer aparezca...");
          }
        }, 3000); // revisa cada 300ms
      }

      // Inicia todo
      document.addEventListener("DOMContentLoaded", function () {
        waitForDrawerAndObserve();
        addCartPageTermsValidation();
      });